import React, { useState, useEffect , useRef} from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Paginador from './Paginador';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import DialogConfirm from './DialogConfirm';

import ReviewDetail from './ReviewDetail';

import UpSpinner from '../FileUpload/UpSpinner';

//lineasdetalletmp

import { ApiCallGet , ApiCallPost } from '../ApiCall/ApiCall';


export default function ReviewTemporal() {
    const [products, setProducts] = useState([]);
    const [start,setStart] = useState( 0 )
    const [limit,setLimit] = useState( 10 )
    const [min,setMin] = useState( 0 )
    const [max,setMax] = useState( 0 ) // El maximo de la consulta anterior
    const [count,setCount] = useState( 120 )
    const [records,setRecords] = useState([])
    const [show,setShow] = useState( false )
    const [isLoading,setIsLoading] = useState( false )
    const [params,setParams] = useState( null )

    const toast = useRef() ;

    useEffect(() => {

        //setShow( !show )

    } , [])

    function onAnswer( val )
    {
        console.log( "onAnswer = " , val )

        if ( val === true )
        {
            setIsLoading( true )
            toast.current.show({ severity: 'info', summary: 'Success', detail: 'Iniciando Carga de Archivo' });


            ApiCallPost('moveproduction' , { user : 'Digital'})
            .then((response)=>{

                setIsLoading( false )
                console.log( 'moveproduction' , response )

                toast.current.show({ severity: 'info', summary: 'Success', detail: 'Archivo Cargado' });


            })
            .catch((err)=>{

                console.log( err )

                setIsLoading( false )

                toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo cargar archivo' , life: 6000 });


            })

        }

    }

    function onProduccion() // moveproduction
    {
        setShow( true  )
    }

    function onRowClick( val)
    {
        console.log( "onRowClick = " , val )
        setParams( val.data )
    }

    function onChangeValues( val )
    {

        console.log( "max = " + max  )

        console.log( "values = " , val )

        setLimit( val.rows )
        //setMax( val.first )

        //callTemporal( records[records.length-1].id , val.rows )

        callTemporal( val.rows * val.page  , val.rows )


    }

    useEffect(() => {

        callTemporal(0,10)
        
    }, []);

    function callTemporal( start , recs ) // Aqui solo va para arriba
    {
        console.log( "temporal = atart = " + start + " recs = " + recs  )

        ApiCallGet( "lineasdetalletmp?start=" + start + "&limit=" + recs )
        .then((response)=> {

            console.log( "count = " + response.count , " min " + response.min + " max = " + response.max  )

            setCount( response.count)

            //setMin( min => response.min )
            //setMax( max => response.max )


            for( var i = 0 ; i < response.rows.length ; i++ )
            {


                response.rows[i].fechaactivacion = new Date( response.rows[i].fechaactivacion )

                response.rows[i].fechaactivacion = addHoursToDate(response.rows[i].fechaactivacion , 6); 

                response.rows[i].fechaactivacion = getFormatDateShort( response.rows[i].fechaactivacion ) 

                if ( response.rows[i].fechaexpiracion !== null )
                {
                    
                    response.rows[i].fechaexpiracion = new Date( response.rows[i].fechaexpiracion )

                    response.rows[i].fechaexpiracion = addHoursToDate(response.rows[i].fechaexpiracion , 6);

                    response.rows[i].fechaexpiracion = getFormatDateShort( response.rows[i].fechaexpiracion )
                }


                if ( response.rows[i].fechaprimerevento !== null )
                {
                    response.rows[i].fechaprimerevento = new Date( response.rows[i].fechaprimerevento )
                    response.rows[i].fechaprimerevento = addHoursToDate(response.rows[i].fechaprimerevento , 6);
                }

                response.rows[i].fechaprimerevento = ( response.rows[i].fechaprimerevento === null || response.rows[i].fechaprimerevento === undefined || isNaN( response.rows[i].fechaprimerevento )? null : getFormatDateShort( response.rows[i].fechaprimerevento ) ) 


                if ( response.rows[i].fechaprimerrecarga !== null )
                {
                    response.rows[i].fechaprimerrecarga = new Date( response.rows[i].fechaprimerrecarga )
                    response.rows[i].fechaprimerrecarga = addHoursToDate(response.rows[i].fechaprimerrecarga , 6);
                }

                response.rows[i].fechaprimerrecarga = ( response.rows[i].fechaprimerrecarga === null ? null : getFormatDateShort( response.rows[i].fechaprimerrecarga ) ) 


                if ( response.rows[i].fechaultimarecarga !== null )
                {
                    response.rows[i].fechaultimarecarga = new Date( response.rows[i].fechaultimarecarga )
                    response.rows[i].fechaultimarecarga = addHoursToDate(response.rows[i].fechaultimarecarga , 6);
                }
    
                                
                response.rows[i].fechaultimarecarga = ( response.rows[i].fechaultimarecarga === null ? null : getFormatDateShort( response.rows[i].fechaultimarecarga ))


            }
    

            // for( var i = 0 ; i < response.rows.length ; i++ )
            // {
            //     response.rows[i].fechaactivacion = getFormatDate( response.rows[i].fechaactivacion ).substring( 0 , 10 )
            //     response.rows[i].fechaexpiracion = getFormatDate( response.rows[i].fechaexpiracion ).substring( 0 , 10 )
            //     response.rows[i].fechaprimerevento = getFormatDate( response.rows[i].fechaprimerevento ).substring( 0 , 20 )
            //     response.rows[i].fechaexpiracion = getFormatDate( response.rows[i].fechaexpiracion ).substring( 0 , 20 )
            //     response.rows[i].fechaprimerrecarga = ( response.rows[i].fechaprimerrecarga === null ? null : getFormatDate( response.rows[i].fechaprimerrecarga ).substring( 0 , 20 )) 
            //     response.rows[i].fechaultimarecarga = ( response.rows[i].fechaultimarecarga === null ? null : getFormatDate( response.rows[i].fechaultimarecarga ).substring( 0 , 20 )) 

            // }



            setRecords( response.rows )

        })
        .catch((err)=>{
            console.log( err )
        })

    }

    function addHoursToDate(date, hours) {

        //console.log( "type = " , typeof( date ))

        return new Date(date.getTime() + hours * 60 * 60 * 1000);
    }

    function getFormatDate(d) {
        var date = new Date(d);
        var dateStr =
            date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2) + " " +
          ("00" + date.getHours()).slice(-2) + ":" +
          ("00" + date.getMinutes()).slice(-2) + ":" +
          ("00" + date.getSeconds()).slice(-2);
        //console.log(dateStr);
      
        return dateStr;
      }

    function getFormatDateShort(d) {
        var date = new Date(d);
        var dateStr =
            date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2)  
 
        //console.log(dateStr);
      
        return dateStr;
      }


    return (
        <div className="card" >

            <Toast ref={toast} />

            <div className='flex justify-content-center'>
                <h3>Revisión de Datos Temporales</h3>
            </div>

            {
                isLoading === true && (
                    <UpSpinner></UpSpinner>
                )

            }

            <div style={{overflowY :'scroll', height : '74vh'}}>

            <DataTable value={records} stripedRows scrollable={true}
                tableStyle={{ minWidth: '50rem' }} onRowClick={(val) => onRowClick(val)}>
                <Column field="id" header="Id"></Column>
                <Column field="numero" header="Telefono"></Column>
                <Column field="fechaactivacion" header="Fecha Activación"></Column>
                <Column field="iccid" header="Imei"></Column>
                <Column field="ofertaprimaria" header="Oferta Primaria"></Column>
                <Column field="estatus" header="Estatus"></Column>
                <Column field="fechaprimerevento" header="Fecha Primer Evento"></Column>
                <Column field="fechaexpiracion" header="Fecha Expiración"></Column>
                <Column field="fechaprimerrecarga" header="Fecha primer Recarga"></Column>
                <Column field="numeroderecargas" header="Número de Recargas"></Column>
                <Column field="fechaultimarecarga" header="Fecha última Recarga"></Column>
                <Column field="diasrecargados" header="Dias Recargados"></Column>
                <Column field="saldo" header="Saldo"></Column>
            </DataTable>
            </div>

            <Paginador theFirst={min} setTheRows={(val) => onChangeValues( val )} theRecords={count}></Paginador>

            <ReviewDetail record={params}></ReviewDetail>
 

            <div className='flex justify-content-center'>
                <Button onClick={onProduccion} label="Subir a Producción"></Button>
            </div>

            <div className='mt-5'>
                <DialogConfirm show={show} answer={onAnswer}></DialogConfirm> 
            </div> 


            
        </div>
    );
}

// select id ,  idmaster , fechaactivacion , imei , ofertaprimaria , estatus , ( select numero from lineasdatamaster datamaster where id = idmaster  ) as numero  from lineasdatadetalletmp where id > ? limit ?"
